import { api as apiExports } from '../api';
import { routes } from "../api/routes";

import axios from 'axios';
import { environment as env, environment } from '../../environments/environment';
import { CreateQueryParams } from '../../helpers';

const {
    Interceptor: api,
    // routes
} = apiExports;

export const fetchPayrollTickets = async (payload = {}, headers) => {
    let query_params = CreateQueryParams(payload)
    return await api.get(
        routes.Payroll.tickets + query_params,
        headers
    );

};

export const fetchPendingPayrollTickets = async (payload, headers) => {
    let query_params = CreateQueryParams(payload)
    return await api.get(
        routes.Payroll.pending_tickets + query_params,
        headers
    );
};

export const approveTicket = async (id, payload = {}, headers) => {
    return await api.put(
        routes.Payroll.approve_ticket + id,
        payload,
        headers
    );
};

export const fetchTicketByID = async (payload, headers) => {

    const { id } = payload;
    return await api.get(routes.Payroll.ticket + id, payload, headers);

};

export const closeTicket = async (id, payload, headers) => {
    return await api.put(
        routes.Payroll.close_ticket + id,
        payload,
        headers
    );
};
